// Module
var code = "<template class=\"step-content\" show.bind=\"visible\" >\n  <h2>${stepTitle}</h2>\n    <slot></slot>\n</template>\n";
// Exports
export default code;